import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-myLive_type",
  "use": "icon-myLive_type-usage",
  "viewBox": "0 0 20 21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 21\" id=\"icon-myLive_type\">\r\n  <path id=\"icon-myLive_type_联合_44\" data-name=\"联合 44\" class=\"cls-1\" d=\"M3402-1611v-3h18v3Zm1-5a2,2,0,0,1-2-2v-12a2,2,0,0,1,2-2h16a2,2,0,0,1,2,2v12a2,2,0,0,1-2,2Zm5.5-9.777v4.554a1,1,0,0,0,1,1,1,1,0,0,0,.494-.133l3.985-2.277a.992.992,0,0,0,.5-.869.989.989,0,0,0-.5-.869l-3.985-2.276a.981.981,0,0,0-.495-.134A1,1,0,0,0,3408.5-1625.777Z\" transform=\"translate(-3401 1632)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol